import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";

export const useCopyToClipBoard = () => {
  const { t } = useTranslation("file-explorer");
  const { enqueueSnackbar } = useSnackbar();
  const handleCopyClick = React.useCallback(
    (text: string | undefined) => {
      if (!text) return;
      try {
        if ("clipboard" in navigator) {
          navigator.clipboard.writeText(text).catch(() => {
            throw new Error("");
          });
        } else {
          document.execCommand("copy", true, text);
        }
        enqueueSnackbar(t("link-copy-success"), {
          variant: "info",
          autoHideDuration: 4000,
        });
      } catch {
        enqueueSnackbar(t("link-copy-failed"), {
          variant: "warning",
          autoHideDuration: 4000,
        });
      }
    },
    [enqueueSnackbar, t],
  );

  return { handleCopyClick };
};
// voi työstää eteenpäin. kommentteja alla
export const getMaterialTableContent = ({
  tableRef,
}: {
  tableRef: React.MutableRefObject<any>;
}) => {
  // const table =
  //   tableRef.current?.tableContainerDiv?.current.querySelector("table");
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const tableConteinerDivRef = tableRef.current
    ?.tableContainerDiv as React.MutableRefObject<HTMLDivElement | undefined>;

  const tHead = tableConteinerDivRef?.current?.querySelector("thead");

  const tBody = tableConteinerDivRef?.current?.querySelector("tbody");
  if (!tHead || !tBody) throw new Error("not found");

  const tableHeaderColumns = tHead.innerText.split("\t\n");
  // if checkki jos on toimintoja niin silloin vain poistetaan eka column arvo

  if (
    tableHeaderColumns.includes("Actions") ||
    tableHeaderColumns.includes("Toiminnot")
  )
    tableHeaderColumns.shift();

  const fixedHeaders = tableHeaderColumns.map((element) => {
    return element.replace("\n", "\t");
  });

  const filteredHeaders = fixedHeaders.join("").replace(/\n\n\n/g, "\n");

  // tässä voisi hakea kaikkien actioneiden nimet ja poistaa ne

  const filteredTbody = tBody.innerText
    .replace(/visibility/g, "")
    .replace(/delete/g, "")
    .replace(/edit/g, "")
    .replace(/map/g, "")
    .split("\n\n\n");

  const parsedBody = filteredTbody
    .map((str, i) => {
      let elementString = str;
      if (i === 0) elementString = elementString.replace("\n\n", "");
      return elementString.replace("\t", "");
    })
    .join("");

  const finalString = `${filteredHeaders}${parsedBody}`;

  return finalString;
};
